<template>
<div class="message">
  <div class="content">
    <div
      v-if="!nullDataFlag"
      class="top-module">
      <h5>{{$t('System_Information')}}</h5>
      <el-button
        color="primary"
        type="border"
        :loading="readAllLoading"
        @click="readAllHandle"
      >{{$t('All_have_been_read')}}</el-button>
    </div>
    <div
      v-if="nullDataFlag"
      class="no-data"
    >{{$t('root.noData')}}</div>
    <div class="message-list">
      <div
        v-for="(item,index) in listData"
        :key="index"
        class="message-item">
        <p>
          <span
            v-if="item.readFlag === 0"
            class="cicle"></span>
          {{getContent(item)}}
        </p>
        <div class="time">{{item.createTime}}</div>
      </div>
    </div>
    <div class="pagination-outer" v-if="total > 10">
      <div class="paginnation-left">
        <size-change @sizeChange="sizeChange"></size-change>
        <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
      </div>
      <vs-pagination
        class="pagination-box"
        :max="max"
        :total="pageSize"
        v-model="page"
      ></vs-pagination>
    </div>
  </div>
</div>
</template>

<script>
import { readAllNotice } from '@/api/user'
import initData from "@/mixins/initData";
import { mapGetters } from 'vuex'
export default {
  name: "index",
  data() {
    return {
      total: 0,
      listData: null,
      readAllLoading: false,
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo','language']),
    nullDataFlag(){
      return this.listData !== null && !this.listData.length;
    },
  },
  created(){
    this.$nextTick(() => {
      this.init().then((res) => {
        this.$emit('send-msg-count',res.data.statistics.unreadNumber);
      });
      // this.$store.commit('setListRefresh',!this.listRefresh);
    })
  },
  methods: {
    beforeInit(){
      this.params = {
        custId: this.userInfo.id,
        page: this.page - 1,
        size: this.size,
      }
      this.url = '/crm/reception/notice';
      return true;
    },
    getContent(item){
      switch (this.language) {
        case 'zh_CN':
          return item.noticeContent;
        case 'en_US':
          return item.noticeContentEn;
        case 'zh_Hant':
          return item.noticeContentHant;
      }
    },
    readAllHandle() {
      this.readAllLoading = true;
      readAllNotice({custId: this.userInfo.id}).then((res) => {
        this.readAllLoading = false;
        this.$emit('readall-msg');
        this.page = 1;
        this.init();
      }).catch((error) => {
        this.readAllLoading = false;
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.message {
  .no-data {
    text-align: center;
    height: 200px;
    line-height: 200px;
  }
}
</style>
